// Source: https://play.tailwindcss.com/GsKP70hLcq?file=css

module.exports = () => ({
  ".clear-sender-container": {
    "@apply ds-container ds-mx-auto ds-grid ds-max-w-[1410px] ds-px ds-mt-xl": true,
  },
  ".clear-sender": {
    "@apply ds-relative ds-border-t ds-border-[#CCCC] ds-py-sm ds-font-regular ds-text-sm ds-text-primary-gray": true,
  },
});
